import React, { ReactElement } from "react";
import CSVReader from "react-csv-reader";
import Autocomplete from "@material-ui/lab/Autocomplete";

import styled from "styled-components";
import { TextField } from "@material-ui/core";

import SlideButton from "./SlideButton";
import InputWithButton from "./InputWithButton";
import Button from "./Button";

interface Props {
  setData: React.Dispatch<React.SetStateAction<{ [id: number]: any }>>;
  chunk: number;
  setChunk: React.Dispatch<React.SetStateAction<number>>;
  setYValue: React.Dispatch<React.SetStateAction<string | null>>;
  isPercent: boolean;
  isShowedAll: boolean;
  setIsPercent: React.Dispatch<React.SetStateAction<boolean>>;
  setIsShowedAll: React.Dispatch<React.SetStateAction<boolean>>;
  setIsShowedTable: React.Dispatch<React.SetStateAction<boolean>>;
  failureCriterion: number;
  setFailureCriterion: React.Dispatch<React.SetStateAction<number>>;
  isShowedTable: boolean;
  yValues: string[];
  setYValues: React.Dispatch<React.SetStateAction<string[]>>;
  setConfigCustomFailures: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function Config({
  setData,
  setYValue,
  chunk,
  setChunk,
  isPercent,
  setIsPercent,
  isShowedAll,
  setIsShowedAll,
  setIsShowedTable,
  failureCriterion,
  setFailureCriterion,
  isShowedTable,
  yValues,
  setYValues,
  setConfigCustomFailures,
}: Props): ReactElement {
  const onFileLoad = (data: any[]): void => {
    let tmp = data.splice(0, 1)[0];
    if (!tmp) {
      return;
    }
    let result: any = {};
    data.forEach((row: [], i: number) => {
      let obj: { [index: string]: number } = {};
      row.forEach((e, i) => {
        obj[tmp[i]] = tmp[i] !== "EREIGNIS" ? parseFloat(e) : e;
      });
      if (!obj.ELEMENT) {
        return;
      }
      if (!(obj.ELEMENT in result)) {
        result[obj.ELEMENT] = {};
        Object.keys(obj).forEach((e) => {
          result[obj.ELEMENT][e] = [obj[e]];
        });
      } else {
        Object.keys(obj).forEach((e) => {
          result[obj.ELEMENT][e].push(obj[e]);
        });
      }
    });
    setData(result);
    if (tmp) {
      setYValues(
        tmp.filter(
          (e: string) => e !== "ZYKLUS" && e !== "E" && e !== "EREIGNIS"
        )
      );
    }
  };

  return (
    <Container>
      <CSVReader onFileLoaded={onFileLoad} />
      <div style={{ marginTop: "-35px", width: "150px" }}>
        <Autocomplete
          options={yValues}
          onChange={(event, value) => {
            setYValue(value);
          }}
          renderInput={(params) => (
            <TextField {...params} label="y-value" margin="normal" />
          )}
        />
      </div>

      <InputWithButton
        text="Reduce Resolution"
        value={chunk}
        setValue={setChunk}
      />

      <SlideButton
        isChecked={isPercent}
        setIsChecked={setIsPercent}
        text2="In %"
        text="Absolute"
      />

      <SlideButton
        isChecked={isShowedAll}
        setIsChecked={setIsShowedAll}
        text2="All in one"
        text="Split"
      />

      <InputWithButton
        text="Failure Criterion"
        value={failureCriterion}
        setValue={setFailureCriterion}
      />

      <Button
        text="Custom Failures Criterions"
        onClick={() => {
          setConfigCustomFailures(true);
        }}
      />

      <Button
        text={isShowedTable ? "Diagrams" : "Sample Listing"}
        onClick={() => {
          setIsShowedTable(!isShowedTable);
        }}
      />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: #93b5c6;
  margin-bottom: 5px;
  align-items: center;
  padding-right: 5px;
  padding-left: 5px;
`;
